import Fueltypes from "./Fueltypes";

import ApiVolumesTrims from '../../api/volumestrims';

import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from 'react';
import { volumes as actionsVolumes, log as actionsLog  } from "../../store/actions";

import { FaTimes, FaEye, FaEyeSlash } from 'react-icons/fa';

const { addToLog } = actionsLog;
const { getVolumes } = actionsVolumes;

const Volumes = ({ model, onSelected }) => {

    const dispatch = useDispatch();

    let [selected, setSelected] = useState([]);
    let [volumesByModel, setVolumesByModel] = useState([]);
    let [selectedVolumeByModel, setSelectedVolumeByModel] = useState(null);
    let [shouldShowVolume, setShouldShowVolume] = useState(-1);

    let volumes = useSelector(store => store.volumes.items);

    useEffect(() => {
        setSelectedVolumeByModel(null);
        dispatch(getVolumes());
        if (model) {
            ApiVolumesTrims.getVolumesByModel(model.id).then(data => setVolumesByModel(data.volumes));
        }
    }, [model]);

    useEffect(() => {
        if(selectedVolumeByModel === null) {
            setShouldShowVolume(-1);
        } else {
            ApiVolumesTrims.getShowVolume(model.id, selectedVolumeByModel.id).then(data => setShouldShowVolume(data.showVolume ? 1 : 0));
        }

    }, [selectedVolumeByModel]);

    const handleChange = e => {
        let value = Array.from(e.target.selectedOptions, option => Number(option.value));
        setSelected(value);
    }

    const addToModel = () => {
        let proceed = window.confirm(`Add selected volumes to model: ${model.name} [${model.id}]?`);
        if (proceed) {
            ApiVolumesTrims.addVolumesToModel(selected, model.id).then(resp => {
                dispatch(addToLog(resp));
                setSelected([]);
                ApiVolumesTrims.getVolumesByModel(model.id).then(data => setVolumesByModel(data.volumes));
            });
        }
    }

    const clear = () => {
        let proceed = window.confirm(`Clear volumes for model: ${model.name} [${model.id}]?`);
        if (proceed) {
            let volumes = volumesByModel.map(v => Number(v.id));
            ApiVolumesTrims.deleteVolumesFromModel(volumes, model.id).then(resp => {
                dispatch(addToLog(resp));
                setVolumesByModel([]);
                setSelectedVolumeByModel(null);
            });
        }
    }

    const deleteVolumeFromModel = volume => {
        let proceed = window.confirm(`Delete volume ${volume.volume} for model: ${model.name} [${model.id}]?`);
        if (proceed) {
            if (volume.id == selectedVolumeByModel.id) {
                setSelectedVolumeByModel(null);
            }
            ApiVolumesTrims.deleteVolumesFromModel([Number(volume.id)], model.id).then(resp => {
                dispatch(addToLog(resp));
                ApiVolumesTrims.getVolumesByModel(model.id).then(data => setVolumesByModel(data.volumes));
            });
        }
    }

    const setVolumeByModel = (volume, e) => {
        setSelectedVolumeByModel(volume);
        onSelected(volume);
    }

    const changeShowVolume = () => {
        let text = shouldShowVolume == 1 ? 'Hide' : 'Show';
        let proceed = window.confirm(`${text} volume ${selectedVolumeByModel.volume} for model: ${model.name} [${model.id}]?`);
        if (proceed) {
            ApiVolumesTrims.updateShowVolume(model.id, selectedVolumeByModel.id, shouldShowVolume != 1).then(resp => {
                dispatch(addToLog(resp));
                setShouldShowVolume(!shouldShowVolume);
            });
        }
    }

    const listClasses = id => {
        const common = 'flex items-center p-2 border-b border-gray-700';
        const specific = selectedVolumeByModel?.id == id ?
            "bg-gray-700 text-white" : "cursor-pointer hover:bg-gray-700";
        return `${common} ${specific}`;
    }

    const eyeClass = () => {
        return (
            selectedVolumeByModel && shouldShowVolume == 1 ? 
            <FaEye /> :
            <FaEyeSlash />
        )
    }

    return (
        <div className="border border-gray-700">
            <div className="text-lg p-2 bg-gray-900 flex items-center justify-between">
                Volumes
            </div>
            <div className="flex flex-wrap overflow-hidden">
                <div className="w-1/3 overflow-hidden">
                    <div className="p-2">
                        <select onChange={handleChange} multiple className="text-sm py-1 mb-2 bg-gray-800 w-full border border-gray-700" 
                            style={{height: 300}}>
                            {volumes.map(volume => {
                                return <option value={volume.id} key={volume.id}>{volume.volume}</option>
                            })}
                        </select>
                        <button disabled={! selected.length} onClick={addToModel}
                            className="border border-blue-700 bg-blue-800 cursor-pointer hover:bg-blue-700 hover:border-blue-800 text-white rounded p-2 flex-1 w-full">Add to model</button>
                    </div>
                </div>

                <div className="w-2/3 overflow-hidden">
                    <div className="p-2 flex flex-col h-full">
                        {
                            volumesByModel.length ? 
                            <ul style={{ height: 300, overflowY: "auto" }} className="border border-gray-700 mb-2">
                            { 
                                volumesByModel.map(
                                    item => 
                                    <li className={listClasses(item.id)} key={ item.id } onClick={e => setVolumeByModel(item, e)}>
                                        { item.volume } 
                                        <div className="ml-auto">
                                        {
                                            selectedVolumeByModel && item.id == selectedVolumeByModel.id ?
                                            <button className="p-1 text-gray-300 hover:text-white rounded border border-gray-600 hover:bg-green-500" onClick={changeShowVolume}>
                                                {eyeClass()}
                                            </button> :
                                            ''
                                        }
                                        <button className="ml-2 p-1 text-gray-300 hover:text-white rounded border border-gray-600 hover:bg-yellow-500"
                                            onClick={() => deleteVolumeFromModel(item)}>
                                            <FaTimes />
                                        </button>
                                        
                                        </div>
                                        
                                    </li>
                                ) 
                            }
                            </ul> : 
                            <div className="p-2 border border-gray-700 mb-2">
                                No volumes for selected model
                            </div>
                        }
                        
                        <button disabled={! volumesByModel.length} onClick={clear}
                            className="mt-auto border border-blue-700 bg-blue-800 cursor-pointer hover:bg-blue-700 hover:border-blue-800 text-white rounded p-2 ml-auto">Clear</button>
                    </div>
                </div>
            </div>
            {
                selectedVolumeByModel ?
                <div className="p-2">
                    <Fueltypes selectedModel={model} selectedVolume={selectedVolumeByModel} />
                </div>
                : <></>
            }
        </div>
        )
}

export default Volumes;